<div class="directional-graph-container">
    <p>{{title}}</p>
    <div class="graph-wrapper"></div>
</div>